// Conversation content for "Experience with building systems" topic
// Edit this file to update the conversation content

const systemsConversation = {
  id: 'systems',
  title: 'Building Systems',
  messages: [
    "I like to think in systems first, even when I’m deep in the UI and UX details.",
    "",
    "Most of my career has been spent in the 'guts' of the product—data platforms, recommendation engines, and the engagement levers that other teams build on.",
    "",
    "To me, growth and systems are two sides of the same coin.",
    "",
    "You use scrappy growth work to find the signal, then you codify those patterns into a system that can tap that value at scale.",
    "",
    "I love the technical side of the puzzle: designing the data contracts, the APIs, and the guardrails that keep everything sane at scale.",
    "",
    "Recently, I’ve focused on the systems that powered Credit Karma’s scale from sub-$1B to over $2B in revenue.",
    "",
    "That involved making it easier for teams to discover value, reuse building blocks, and ship experiments without reinventing the wheel every time.",
    "",
    "That’s the fun part for me: zooming between growth and systems and making sure they keep feeding each other."
  ]
};

export default systemsConversation;





